import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import * as moment from "moment";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AccVoucherDetail } from "src/app/backoffice/acc/models/accvoucherdetail.model";
export interface EnumStatusModel {
  Title: string;
}
export enum StatusEnum {
  "ارسال موفق" = 1,
  "در حال انتظار" = 2,
  "منقضی شده" = 3,
  "خطا در ارسال" = 4,
  "در حال ارسال" = 5,
}
export interface ConfirmDateValue {
  EndDate: Date;
  StartDate: Date;
  HasInvoiceService: boolean;
  HasGetResponse: boolean;
  ResendFactors: boolean;
  StatusCode: number;
  closeDialog: Function;
}

@Component({
  selector: "ngx-dateDialog",
  templateUrl: "./dateDialog.component.html",
  styleUrls: ["./dateDialog.component.scss"],
})
export class DateDialogComponent extends BaseFormComponent<any> {
  confirmValue: Subject<ConfirmDateValue>;
  DetailLedgerList: AccVoucherDetail[];
  gridColumns: form_control[];
  accVoucerherDetailcolumns: form_control[];
  statusDataList: EnumStatusModel[];

  DateValueFormGroup: FormGroup = new FormGroup({
    StartDate: new FormControl(null),
    EndDate: new FormControl(null),
    HasInvoiceService: new FormControl(false),
    HasGetResponse: new FormControl(false),
    ResendFactors: new FormControl(false),
    StatusCode: new FormControl(false),
  });

  autoCancel = true;
  hasAcc = false;
  hasDeposit = false;
  setDefaultDate = false;
  hasResponse = false;
  hasResendFactors = false;
  statusList = false;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "";
    if (!this.label) this.label = "";
    this.areaName = "";
    super.ngOnInit();
    this.GetColumns();
    this.statusDataList = this.enumToEnumModelArray(StatusEnum);
    if (this.setDefaultDate) {
      const m = moment();
      const nowDate = m.locale("fa").format("YYYY/MM/DD");
      this.DateValueFormGroup.controls["StartDate"].setValue(nowDate);
      this.DateValueFormGroup.controls["EndDate"].setValue(nowDate);
    }
  }

  async setColumns(): Promise<void> {}

  submitValue() {
    const confirmValue = this.DateValueFormGroup.value;
    if (confirmValue?.StartDate && confirmValue?.EndDate) {
      if (confirmValue?.StartDate > confirmValue?.EndDate) {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.DateDialog.ValueFromDateSmallerThanValueUntilDate"),
          this.translate("ClientApp.FrontOffice.DateDialog.DateSelection")
        );
        this.selectorService.submitted$.next(false);
        this.cd.markForCheck();
        return;
      }
      confirmValue.StartDate.setHours(0, 0, 0, 0);
      confirmValue.EndDate.setHours(23, 59, 59, 999);
      this.confirmValue.next({ ...confirmValue, closeDialog: this.cancel.bind(this) });
      if (this.autoCancel) this.cancel();
      this.closeModal();
    } else {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.DateDialog.EnterDateRange"),
        this.translate("ClientApp.FrontOffice.DateDialog.DateSelection")
      );
      this.selectorService.submitted$.next(false);
      this.cd.markForCheck();
    }
  }

  public cancel(): void {
    this.confirmValue.next(null);
    super.cancel();
  }
  async GetColumns() {
    await this.httpCommonService
      .getControlsList("CashierSettlemet/GetColumnInfo", true)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.gridColumns = data as form_control[];
            this.gridColumns = this.gridColumns.sort((a, b) => a.order - b.order);
          }
        },
        (error) => console.log(error)
      );
  }
  enumToEnumModelArray(enumObj: any): EnumStatusModel[] {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .map((key) => ({ Id: enumObj[key], Title: key }));
  }
}
